import React, { useState } from 'react';
import './PackageSizeSelector.css';

const PackageSizeSelector = ({ onSelect, selectedSize }) => {
    const [weight, setWeight] = useState('');
    const [currentlySelected, setCurrentlySelected] = useState(selectedSize || null);

    const packageSizes = [
        {
            id: 'small',
            name: 'Small',
            description: 'Up to 25cm x 15cm x 10cm',
            dimensions: { width: 50, height: 30 }
        },
        {
            id: 'medium',
            name: 'Medium',
            description: 'Up to 35cm x 25cm x 15cm',
            dimensions: { width: 70, height: 50 }
        },
        {
            id: 'large',
            name: 'Large',
            description: 'Up to 45cm x 35cm x 25cm',
            dimensions: { width: 90, height: 70 }
        }
    ];

    const handleSizeClick = (sizeId) => {
        setCurrentlySelected(sizeId);
    };

    const parsedWeight = parseFloat(weight);
    const isWeightValid = Number.isFinite(parsedWeight) && parsedWeight > 0;

    const handleContinue = () => {
        if (currentlySelected && isWeightValid) {
            onSelect(currentlySelected, weight.trim());
        }
    };

    const handleCancel = () => {
        setCurrentlySelected(null);
        setWeight('');
    };

    return (
        <div className="package-size-selector">
            <h3>Select Package Size</h3>
            <div className="package-options">
                {packageSizes.map((size) => (
                    <div
                        key={size.id}
                        className={`package-option ${currentlySelected === size.id ? 'selected' : ''}`}
                        onClick={() => handleSizeClick(size.id)}
                    >
                        <div className="package-box-container">
                            <div 
                                className="package-box" 
                                style={{
                                    width: `${size.dimensions.width}px`,
                                    height: `${size.dimensions.height}px`
                                }}
                            />
                        </div>
                        <div className="package-info">
                            <h4>{size.name}</h4>
                            <p>{size.description}</p>
                        </div>
                    </div>
                ))}
            </div>
            
            {currentlySelected && (
                <>
                    <div className="weight-input-container">
                        <label htmlFor="package-weight">Package Weight</label>
                        <div className="weight-input-group">
                            <input
                                id="package-weight"
                                type="number"
                                value={weight}
                                onChange={(e) => setWeight(e.target.value)}
                                placeholder="Enter weight"
                                step="0.1"
                                min="0.1"
                                required
                            />
                            <span className="weight-unit">kg</span>
                        </div>
                    </div>
                    
                    <div className="package-actions">
                        <button 
                            type="button" 
                            className="cancel-button" 
                            onClick={handleCancel}
                        >
                            Cancel
                        </button>
                        <button 
                            type="button" 
                            className="continue-button" 
                            onClick={handleContinue}
                            disabled={!isWeightValid}
                        >
                            Continue
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default PackageSizeSelector; 
